/**
 * Legal pages are static files next to the built app, not Vue routes, so the link is
 * built from the deploy base path. `lang` is passed on because each page is bilingual
 * and would otherwise pick the language of the device rather than the one chosen in the app.
 */
const legalPageUrl = (file: string, language: string): string => {
  const base = process.env.BASE_URL || '/';
  return `${base}${file}?lang=${language === 'ru' ? 'ru' : 'en'}`;
};

export const privacyPolicyUrl = (language: string): string =>
  legalPageUrl('privacy.html', language);

export const termsOfServiceUrl = (language: string): string => legalPageUrl('terms.html', language);
